/* globals process, NativeStorage */

import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import Auth from './store/auth';
import Form from './store/form';
import SelectCache from './store/select-cache';

Vue.use(Vuex);

/** Default values */
let default_opportunities = {
	query: null,
	sectors: [],
	deal_type: null,
	member_company: null,
	from_date: null,
	to_date: null
};

let default_madds = {
	query: null,
	sectors: [],
	deal_type: null,
	member_company: null,
	from_date: null,
	to_date: null
}

let default_intelligence = {
	query: null,
	sector: [],
	deal_type: null,
	member_company: null,
}

let default_insights = {
	query: null,
	sector: [],
	folder_location: null
}

let default_members = {
	query: null,
	region: null
}

let default_registration = {
    eventId: null,
    arrivalDate: null,
    departureDate: null,
    adultGuests: 0,
    childGuests: 0,
    dietaryRequirements: null,
    requiresAccommodation: true,
    roomRequirements: null,
    completed: false,
}

export default new Vuex.Store({
	state: {
		//storing the users selected dropdown options to the store.
		opportunities: default_opportunities,
		madds: default_madds,
		intelligence: default_intelligence,
		insights: default_insights,
		members: default_members,
        events: [],
        registration: default_registration,
        event: null,
        adultGuests: null,
        childGuests: null,
        eventLoading: true,
	},
	getters: {
		opportunities(state) {
			return state.opportunities;
		},
		madds(state) {
			return state.madds;
		},
		intelligence(state) {
			return state.intelligence;
		},
		insights(state) {
			return state.insights;
		},
		members(state) {
			return state.members;
		},
        events(state) {
            return state.events;
        },
        event(state) {
            return state.event;
        },
        registration(state) {
            return state.registration;
        },
        adultGuests(state) {
            return state.registration.adultGuests;
        },
        childGuests(state) {
            return state.registration.childGuests;
        },
        arrivalDate(state) {
            return state.registration.arrivalDate;
        },
        departureDate(state) {
            return state.registration.departureDate;
        },
        requiresAccommodation(state) {
            return state.registration.requiresAccommodation;
        },
        dietaryRequirements(state) {
            return state.registration.dietaryRequirements;
        },
        roomRequirements(state) {
            return state.registration.roomRequirements;
        },
        registrationCompleted(state) {
            return state.registration.completed;
        },
        eventLoading(state) {
            return state.eventLoading;
        }
 	},
	mutations: {
		modifyOpportunity(state, payload) {
			state.opportunities = payload;
		},
		modifyMadds(state, payload) {
			state.madds = payload;
		},
		modifyIntelligence(state, payload) {
			state.intelligence = payload;
		},
		modifyInsights(state, payload) {
			state.insights = payload;
		},
		modifyMembers(state, payload) {
			state.members = payload;
		},
        modifyEvents(state, payload) {
            state.events = payload;
        },
        modifyEvent(state, payload) {
            state.event = payload;
        },
        modifyRegistration(state, payload) {
            state.registration = payload;
        },
        modifyAdultGuests(state, payload) {
            state.registration.adultGuests = payload;
        },
        modifyChildGuests(state, payload) {
            state.registration.childGuests = payload;
        },
        modifyArrivalDate(state, payload) {
            state.registration.arrivalDate = payload;
        },
        modifyDepartureDate(state, payload) {
            state.registration.departureDate = payload;
        },
        modifyRequiresAccommodation(state, payload) {
            state.registration.requiresAccommodation = payload;
        },
        modifyRoomRequirements(state, payload) {
            state.registration.roomRequirements = payload;
        },
        modifyDietaryRequirements(state, payload) {
            state.registration.dietaryRequirements = payload;
        },
        modifyRegistrationComplete(state, payload) {
            state.registration.completed = payload;
        },
        modifyEventLoading(state, payload) {
            state.eventLoading = payload;
        },
        resetState(state, payload) {
			state.opportunities = default_opportunities;
			state.madds = default_madds;
			state.intelligence = default_intelligence;
			state.insights = default_insights;
			state.members = default_members;
		},
        resetRegistration(state, payload) {
            state.registration = default_registration;
        }
	},
	modules: {
		auth: Auth,
		form: Form,
		selectCache: SelectCache,
	},
	plugins: [
		new VuexPersistence().plugin,
	],
	strict: process.env.NODE_ENV !== 'production',
})
